<template>

    <fieldset class="address-autocomplete">

        <label :for="`address-${ id }`">
            Adresse
            <form-error :content="errors" />
        </label>

        <input 
            :id="`address-${ id }`" 
            type="text" 
            v-model="addr_txt"
            @keyup.arrow-down="highlightNext()"
            @keyup.arrow-up="highlightPrev()"
            @keydown.enter.stop.prevent="selectAddress(choices[i])"
            @keydown.tab="clear()"
            @keyup.escape="clear()"
            @input="fetchAddresses()"
            autocomplete="off"
            required>

        <ul class="suggestions" v-if="choices.length > 0">
            <li 
                v-for="c in choices"
                @click="selectAddress(c)"
                :class="{'highlighted': c.adresse.id === choices[i].adresse.id}">
                {{ c.tekst }}
            </li>
        </ul>
        
    </fieldset>

</template>

<script>

    import axios from 'axios'
    import FormError from './Error.vue'

    export default {

        components: {
            FormError
        },
        props: [
            'errors'
        ],
        data () {
            return {
                id: null,
                choices: [],
                addr_txt: '',
                fetching: false,
                i: 0 // An index we manipulate to highlight address choices
            }
        },
        methods: {
            fetchAddresses: function() { 
                this.fetching = !this.fetching
                if (this.fetching) {
                    return // try not to request anything new while a response is still underway
                }
                axios
                    .get(`https://dawa.aws.dk/adresser/autocomplete/?q=${ this.addr_txt }&noformat`)
                    .then(res => {
                        this.clear()
                        this.choices = res.data
                    })
                    .catch(err => {
                        console.log(err)
                    })
            },
            highlightPrev: function() {
                this.i--
                if (this.i < 0) {
                    this.i = 0
                }
                this.addr_txt = this.choices[this.i].tekst
            },
            highlightNext: function() {
                this.i++
                if (this.i >= this.choices.length) {
                    this.i = this.choices.length -1
                }
                this.addr_txt = this.choices[this.i].tekst
            },
            clear: function() {
                this.fetching = false
                this.choices = []
                this.i = 0
            },
            selectAddress: function(addr) {
                this.addr_txt = addr.tekst    
                this.clear()
                this.$emit('address-pick', addr)
            }
        },
        mounted: function() {
            this.id = this._uid
        }

    }
</script>

<style lang="scss">

    @import '../../styles/vars.scss';

    .address-autocomplete {

        .suggestions {
            position: absolute;
            z-index: 2;
            list-style: none;
            padding: 0;
            margin: -.5rem 0 0;
            border: solid 1px $grey2;
            background-color: $grey0;
            width: auto;
        }
        li {
            padding: .5rem;
            display: block;
            background: transparent;
            width: 100%;
            cursor: pointer;

            &.highlighted {
                background-color: $warning;
            }
        }
    }

</style>